import { useFadeIn } from '@/hooks/useFadeIn';

export default function IconAbout() {
  const left = useFadeIn({ direction: 'up' });
  const right = useFadeIn({ direction: 'up', delay: 300 });

  return (
    <section id="about" className="bg-white py-14 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start gap-10 lg:gap-12">
          <div className="w-full lg:w-[55%]">
            <div ref={left.ref} style={left.style}>
              <span
                className="inline-block font-medium text-xs md:text-sm tracking-[0.2em]"
                style={{ color: '#3E5F8F' }}
              >
                About ICON
              </span>
              <div className="w-8 h-px mt-3 mb-4" style={{ backgroundColor: '#3E5F8F' }}></div>
              <h2 className="font-serif text-gray-900 text-2xl md:text-3xl leading-relaxed mb-6">
                ICON（アイコン）とは何ですか?
              </h2>
              <p className="font-light text-gray-700 text-sm md:text-base leading-loose">
                ICONは、ドイツ・DMG社が開発した<br />
                白斑（ホワイトスポット）改善のための特殊治療です。<br />
                歯の内部に専用の透明な樹脂（インフィルトラント）を<br />
                浸透させることで、白く見える原因となる空気を置き換え、<br />
                周囲の歯と同じ自然な透明感に整えます。
              </p>
              <div
                className="rounded-lg p-5 md:p-6 mt-8 bg-gray-50"
                style={{ borderLeft: '4px solid #3E5F8F' }}
              >
                <h3 className="font-medium text-gray-900 text-sm md:text-base mb-3">
                  ICONが適している白斑
                </h3>
                <ul className="space-y-2">
                  {[
                    '矯正装置（ブラケット）跡の白斑',
                    '虫歯初期のエナメル質白濁',
                    '生まれつきのホワイトスポット',
                  ].map((item) => (
                    <li
                      key={item}
                      className="font-light text-gray-700 text-sm flex items-start gap-2"
                    >
                      <span className="mt-1" style={{ color: '#3E5F8F' }}>・</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[45%]">
            <div ref={right.ref} style={right.style}>
              <div className="rounded-lg overflow-hidden aspect-[4/3]">
                <img
                  alt="歯のホワイトスポットのイメージ"
                  className="w-full h-full object-cover object-top"
                  src="https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/af78950f236072696e6c712c8dd2407f.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}